import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import {StateSnapshot} from "react-virtuoso";

let initialState: StateSnapshot = {
    ranges: [],
    scrollTop: 0
};

export const FeedSnapshotSlice = createSlice({
    name: "feed_snapshot_slice",
    initialState,
    reducers: {
        setSnapshot: (state, action: PayloadAction<StateSnapshot>) => {
            state = action.payload
            return state;
        },
    },
});

export const { setSnapshot } = FeedSnapshotSlice.actions;

export default FeedSnapshotSlice.reducer;